import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/app/app.service";
import { ProductType } from "src/app/core/product/enums";
import { MdbTableDirective } from "ng-uikit-pro-standard";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { OrderFactoryProductData } from "src/app/core/order/analytics/data/data.abstract";
import { OrderFactoryPeriodSummary } from "src/app/core/order/analytics/summaries/summary.abstract";

@Component({
  selector: "ll-summary-by-product",
  templateUrl: "./summary-by-product.component.html",
  styleUrls: ["./summary-by-product.component.scss"]
})
export class SummaryByProductComponent implements OnInit {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;

  columnNames: string[] = [
    "Product",
    "Units",
    "Avg Price",
    "Sub Total",
    "Service Fees",
    "Tips",
    "Tip %",
    "Total",
    "# Redeemed",
    "% Redeemed",
    "% Revenue"
  ];
  constructor(private app: AppService, private router: Router) {}

  ngOnInit() {}

  public get data$(): Observable<OrderFactoryProductData[]> {
    return this.app.state.productTableData$;
  }

  public get totals$(): Observable<OrderFactoryPeriodSummary> {
    return this.app.state.periodTotalData$;
  }

  mask(type: ProductType) {
    return ProductType[type];
  }

  get tUnits(): number {
    // return this.data.reduce((acc, next) => acc + next.units, 0);
    return 0;
  }

  get tAvgPrice(): number {
    // return (
    //   this.data.reduce((acc, next) => acc + next.avgPrice * next.units, 0) /
    //   this.tUnits
    // );
    return 0;
  }

  get tSubtotal() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.subtotal, 0);
  }

  get tServiceFees() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.serviceFees, 0);
  }
  get tTips() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.tips, 0);
  }

  get tTipPercentage() {
    return 0;
    // return this.tTips / this.tTotal;
  }

  get tRedeemedPercentage() {
    return 0;
    // return this.tRedeemed / this.tUnits;
  }

  get tTotal() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.total, 0);
  }

  get tRedeemed() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.redeemed, 0);
  }

  get tRevenue() {
    return 0;
    // return (
    //   this.data.reduce(
    //     (acc, next) => acc + next.total / this.analytics.revenue,
    //     0
    //   ) / this.data.length
    // );
  }
}
